// Qwen Audio 3.0 TTS Flash voices available through OpenRouter.
// https://platform.qianwenai.com/docs/developer-guides/speech/voice-list/qwen-audio-tts
export const READ_ALOUD_VOICES = [
  { value: 'female', providerVoice: 'longanhuan_v3.6' },
  { value: 'male', providerVoice: 'loongjohn' },
];

export const DEFAULT_READ_ALOUD_VOICE = 'female';

export const normalizeReadAloudVoice = (value) => (
  READ_ALOUD_VOICES.some(voice => voice.value === value) ? value : DEFAULT_READ_ALOUD_VOICE
);

export const getReadAloudProviderVoice = (value) => (
  READ_ALOUD_VOICES.find(voice => voice.value === normalizeReadAloudVoice(value)).providerVoice
);
